import { DsLoadingSize } from '@type/ds-loading-size.type';

/**
 * Circular spinner diameter in pixels for each size variant.
 */
export const DS_LOADING_SPINNER_DIAMETER: Record<DsLoadingSize, number> = {
  xs: 16,
  sm: 20,
  md: 36,
  lg: 48,
  xl: 72,
};

/**
 * Circular spinner stroke width in pixels for each size variant.
 */
export const DS_LOADING_SPINNER_STROKE_WIDTH: Record<DsLoadingSize, number> = {
  xs: 2,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5,
};
